import React from 'react';
import { useTranslation } from 'react-i18next';

import { fundsRequestsApi } from 'api';
import { DialogProps, EditCategoryCommentDialog } from 'components';
import { QueryKey } from 'enums';
import { TranslationNamespace } from 'i18n';
import { FundsRequest } from 'types';

import { FundsRequestStatusLabel } from '../FundsRequestStatusLabel';

type Props = DialogProps<FundsRequest>;

export const EditFundsRequestDialog: React.FC<Props> = (props) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.funds_request',
  });

  return (
    <EditCategoryCommentDialog
      {...props}
      onUpdate={(id, values) => fundsRequestsApi.update(id, values)}
      queryKey={QueryKey.FundsRequests}
      dialogTitle={t('edit_category_dialog.title')}
      categoryLabel={t('funds_requests.fields.category')}
      commentLabel={t('funds_requests.fields.comment')}
      getAssetCurrencyId={(data) => data.asset?.assetCurrencyId}
      renderStatusLabel={(data) => (
        <FundsRequestStatusLabel fundsRequest={data} />
      )}
      renderUserLabel={(data) => data.user?.name}
    />
  );
};
